import { Injectable, isDevMode } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { StateStorageService } from './state-storage.service';
import { PATHS } from '../models/bary-paths.model';
import { ICustomer } from '../models/customer.model';
import { CurrentDataService } from './current-data-service';
import { AccountService } from './account.service';
import { User } from '../models/user.model';

@Injectable({ providedIn: 'root' })
export class UserRouteAccessService implements CanActivate {
  constructor(private router: Router, private accountService: AccountService, private stateStorageService: StateStorageService, private currentDataService: CurrentDataService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return forkJoin({
      account: this.accountService.identity().pipe(take(1)),
      customer: this.currentDataService.getCustomer().pipe(take(1)),
    }).pipe(
      map(data => {
        this.stateStorageService.storeUrl(state.url);

        const isAccountValid = this.checkAccount(data.account, route.data['authorities']);
        const isCustomerValid = this.checkCustomer(data.customer);

        if (data.account) {
          if (isAccountValid && isCustomerValid) {
            return true;
          } else if (isAccountValid && !isCustomerValid) {
            this.router.navigateByUrl(PATHS.ACCOUNT_COMMITMENT.path);
            return false;
          } else {
            this.router.navigateByUrl(PATHS.HOME.path);
            return false;
          }
        } else {
          this.router.navigateByUrl(PATHS.HOME.path);
          return false;
        }
      })
    );
  }

  checkAccount(account?: User | null, authorities?: string[]): boolean {
    if (account) {
      if (!authorities || authorities.length === 0 || this.accountService.hasAnyAuthority(authorities)) {
        return true;
      }
      if (isDevMode()) {
        console.error('User has not any of required authorities');
      }
      return false;
    }
    return false;
  }

  checkCustomer(customer?: ICustomer | null): boolean {
    if (this.accountService.hasAnyAuthority(['ROLE_MODERATOR', 'ROLE_ADMIN'])) {
      return true;
    } else if (customer) {
      return this.accountService.checkCommitmentAccepted(customer);
    } else {
      return false;
    }
  }
}
